// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b3a52aad","640":"7b2c89b8","656":"a63baae4"}[chunkId] + ".chunk.js";
};